import { Injectable } from '@angular/core';

/**
 * Thin localStorage wrapper for persisting UI preferences across page loads,
 * tabs, and windows. Keys should be long and descriptive, reflecting the
 * component path and setting — never UI text (i18n-safe).
 *
 * Example key: 'work-batches.batch-list.show-current-only-filter'
 */
@Injectable({ providedIn: 'root' })
export class UserPreferencesService {
  get<T>(key: string, defaultValue: T): T {
    try {
      const raw = localStorage.getItem(key);
      if (raw === null) return defaultValue;
      return JSON.parse(raw) as T;
    } catch {
      return defaultValue;
    }
  }

  set<T>(key: string, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Quota exceeded or private-browsing restriction — silently ignore.
    }
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }
}
